import React from 'react';

import { Tag } from 'antd';

import { PARTNER_HIERARCHY_TYPE, PartnerHierarchyType } from '../types/partner';

const BADGE_CONFIG: Record<
  PartnerHierarchyType,
  { color: string; label: string }
> = {
  [PARTNER_HIERARCHY_TYPE.COMPANY]: { color: 'geekblue', label: 'Company' },
  [PARTNER_HIERARCHY_TYPE.ORGANIZATION]: {
    color: 'cyan',
    label: 'Organization',
  },
};

interface Props {
  partnerType: PartnerHierarchyType | undefined;
}

export const PartnerTypeBadge = ({ partnerType }: Props) => {
  if (!partnerType) return null;

  const { color, label } = BADGE_CONFIG[partnerType];

  return (
    <Tag
      data-testid="partner-type-badge"
      color={color}
      style={{ margin: 0, lineHeight: '1.25rem', fontSize: '0.75rem' }}
    >
      {label}
    </Tag>
  );
};
